/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, TextFormat, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './cash-transaction.reducer';

export const CashTransaction = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const cashTransactionList = useAppSelector(state => state.cashTransaction.entities);
  const loading = useAppSelector(state => state.cashTransaction.loading);
  const totalItems = useAppSelector(state => state.cashTransaction.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="cash-transaction-heading" data-cy="CashTransactionHeading">
        <Translate contentKey="tinyMedicRestApp.cashTransaction.home.title">Cash Transactions</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.cashTransaction.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/cash-transaction/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.cashTransaction.home.createLabel">Create new Cash Transaction</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.cashTransaction.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {cashTransactionList && cashTransactionList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('inOutType')}>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.inOutType">In Out Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('inOutType')} />
                </th>
                <th className="hand" onClick={sort('tenderedAmount')}>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.tenderedAmount">Tendered Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('tenderedAmount')} />
                </th>
                <th className="hand" onClick={sort('qty1')}>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.qty1">Qty 1</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('qty1')} />
                </th>
                <th className="hand" onClick={sort('qty2')}>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.qty2">Qty 2</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('qty2')} />
                </th>
                <th className="hand" onClick={sort('qty5')}>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.qty5">Qty 5</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('qty5')} />
                </th>
                <th className="hand" onClick={sort('qty10')}>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.qty10">Qty 10</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('qty10')} />
                </th>
                <th className="hand" onClick={sort('qty20')}>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.qty20">Qty 20</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('qty20')} />
                </th>
                <th className="hand" onClick={sort('qty50')}>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.qty50">Qty 50</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('qty50')} />
                </th>
                <th className="hand" onClick={sort('qty100')}>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.qty100">Qty 100</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('qty100')} />
                </th>
                <th className="hand" onClick={sort('qty200')}>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.qty200">Qty 200</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('qty200')} />
                </th>
                <th className="hand" onClick={sort('qty500')}>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.qty500">Qty 500</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('qty500')} />
                </th>
                <th className="hand" onClick={sort('qty1000')}>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.qty1000">Qty 1000</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('qty1000')} />
                </th>
                <th className="hand" onClick={sort('qty2000')}>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.qty2000">Qty 2000</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('qty2000')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.cashTransaction.hospital">Hospital</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {cashTransactionList.map((cashTransaction, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/cash-transaction/${cashTransaction.id}`} color="link" size="sm">
                      {cashTransaction.id}
                    </Button>
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.InOutType.${cashTransaction.inOutType}`} />
                  </td>
                  <td>{cashTransaction.tenderedAmount}</td>
                  <td>{cashTransaction.qty1}</td>
                  <td>{cashTransaction.qty2}</td>
                  <td>{cashTransaction.qty5}</td>
                  <td>{cashTransaction.qty10}</td>
                  <td>{cashTransaction.qty20}</td>
                  <td>{cashTransaction.qty50}</td>
                  <td>{cashTransaction.qty100}</td>
                  <td>{cashTransaction.qty200}</td>
                  <td>{cashTransaction.qty500}</td>
                  <td>{cashTransaction.qty1000}</td>
                  <td>{cashTransaction.qty2000}</td>
                  <td>{cashTransaction.active ? 'true' : 'false'}</td>
                  <td>
                    {cashTransaction.microSec ? <TextFormat type="date" value={cashTransaction.microSec} format={APP_DATE_FORMAT} /> : null}
                  </td>
                  <td>
                    {cashTransaction.timestampEntry ? (
                      <TextFormat type="date" value={cashTransaction.timestampEntry} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {cashTransaction.lastUpdated ? (
                      <TextFormat type="date" value={cashTransaction.lastUpdated} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{cashTransaction.cursor}</td>
                  <td>
                    {cashTransaction.hospital ? (
                      <Link to={`/hospital/${cashTransaction.hospital.id}`}>{cashTransaction.hospital.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/cash-transaction/${cashTransaction.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/cash-transaction/${cashTransaction.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/cash-transaction/${cashTransaction.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.cashTransaction.home.notFound">No Cash Transactions found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={cashTransactionList && cashTransactionList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default CashTransaction;
